var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#81BB27;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#3D3C44;}\r\n\t.st3{fill:url(#SVGID_00000029759255957986923590000000285243981201949631_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4,12.9c-0.3-0.5-0.1-1.1,0.3-1.4l2.6-1.6c1.9-1.2,2.5-3.6,1.3-5.5S10.9,2,9,3.1L6.5,4.7 C6,5,5.4,4.8,5.1,4.4C4.8,3.9,5,3.3,5.4,3L8,1.4c2.8-1.7,6.5-0.9,8.3,2s0.9,6.5-2,8.3l-2.6,1.6C11.3,13.5,10.7,13.4,10.4,12.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12,
    y1: 13.305,
    x2: 12,
    y2: 0.8891,
    gradientTransform: "matrix(1 0 0 -1 0 23.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFAB17"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,10.5h12c1.7,0,3,1.2,3,2.7v7.1c0,1.5-1.3,2.7-3,2.7H6c-1.7,0-3-1.2-3-2.7v-7.1C3,11.7,4.3,10.5,6,10.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12,20c-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1s1,0.4,1,1v3C13,19.6,12.6,20,12,20z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016067842922133518370000016492784317766732454_",
    gradientUnits: "userSpaceOnUse",
    x1: 12,
    y1: 10.975,
    x2: 12,
    y2: 6.794,
    gradientTransform: "matrix(1 0 0 -1 0 23.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D5C66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48474F"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000016067842922133518370000016492784317766732454_)"
    },
    cx: 12,
    cy: 15,
    r: 2
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLock);
export default __webpack_public_path__ + "static/media/unLock.6e713f9d9abf8b145a4d8094307af4b5.svg";
export { ForwardRef as ReactComponent };